import React from 'react'
import { Interweave } from 'interweave'

const BlogTemplate = function ({ data }) {
  return <Interweave content={data} />
}

export default BlogTemplate
